var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('div',{ref:"myChart",style:({width: '800px', height: '800px'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }